/**
 * 创建页必填项完成度——供顶栏「N 项待完成」与各 Card 状态角标共用。
 */
import { isWebCoverType, requiresFileUpload } from '../genericResourceUploadRules'
import {
  resolveConfigSectionKind,
  evaluateTypeConfigCompletion,
} from './genericResourceTypeConfigCompletion'

function isFilled(value) {
  return String(value == null ? '' : value).trim() !== ''
}

/**
 * @param {{
 *   ruleForm: object,
 *   unlockData: object,
 *   hasSelectedType: boolean,
 *   typeConfigSnapshot?: object,
 * }} ctx
 */
export function computeGenericResourceCompletion(ctx) {
  const ruleForm = ctx.ruleForm || {}
  const unlockData = ctx.unlockData || {}
  const assetType = ruleForm.assetType
  const pending = []

  // 未选类型时只提示「资源类型」——名称/解锁组等尚未进入可填路径，避免误报「3 项」
  if (!ctx.hasSelectedType) {
    return {
      pendingCount: 1,
      pendingItems: [{ id: 'assetType', label: '资源类型', sectionId: 'header' }],
      sectionStatus: {
        basic: 'pending',
        unlock: 'pending',
      },
      configSectionKind: 'none',
    }
  }

  if (!isFilled(ruleForm.resourceName)) {
    pending.push({ id: 'resourceName', label: '资源名称', sectionId: 'basic' })
  }

  if (requiresFileUpload(assetType)) {
    const url = ruleForm.jsonConfig && ruleForm.jsonConfig.url
    if (!isFilled(url)) {
      pending.push({ id: 'jsonConfig.url', label: '资源文件', sectionId: 'basic' })
    }
  }

  // web：封面写在 thumbUrl（基本信息左侧），与资源包 url 解耦
  if (isWebCoverType(assetType) && !isFilled(ruleForm.thumbUrl)) {
    pending.push({ id: 'thumbUrl', label: '封面图', sectionId: 'basic' })
  }

  const configSection = resolveConfigSectionKind(assetType)
  let typeConfigEval = { complete: true, pending: [], optionalOnly: false }
  if (configSection.kind !== 'none') {
    typeConfigEval = evaluateTypeConfigCompletion(
      assetType,
      ctx.typeConfigSnapshot || {}
    )
    pending.push(...typeConfigEval.pending)
  }

  if (!isFilled(unlockData.defaultLockGroupId)) {
    pending.push({ id: 'defaultLockGroupId', label: '默认解锁组', sectionId: 'unlock' })
  }

  // workout_action：至少关联 1 个 Tag（运营用 Tag 标部位，如胸/背/瑜伽）
  const requiresTags = String(assetType || '') === 'workout_action'
  const tagList = Array.isArray(ruleForm.tagVOList) ? ruleForm.tagVOList : []
  const tagsFilled = tagList.length > 0
  if (requiresTags && !tagsFilled) {
    pending.push({ id: 'tagVOList', label: '关联 Tag', sectionId: 'tag' })
  }

  const basicComplete =
    isFilled(ruleForm.resourceName) &&
    (!requiresFileUpload(assetType) || isFilled(ruleForm.jsonConfig && ruleForm.jsonConfig.url)) &&
    (!isWebCoverType(assetType) || isFilled(ruleForm.thumbUrl))

  const sectionStatus = {
    basic: basicComplete ? 'done' : 'pending',
    unlock: isFilled(unlockData.defaultLockGroupId) ? 'done' : 'pending',
  }
  if (requiresTags) {
    sectionStatus.tag = tagsFilled ? 'done' : 'pending'
  }

  if (configSection.kind === 'typeConfig') {
    if (typeConfigEval.optionalOnly && typeConfigEval.complete) {
      // 全选填：不误导成「已填完必填」
      sectionStatus.typeConfig = 'optional'
    } else {
      sectionStatus.typeConfig = typeConfigEval.complete ? 'done' : 'pending'
    }
  }
  if (configSection.kind === 'schema') {
    sectionStatus.schema = typeConfigEval.complete ? 'done' : 'pending'
  }

  return {
    pendingCount: pending.length,
    pendingItems: pending,
    sectionStatus,
    configSectionKind: configSection.kind,
  }
}
